import styled from 'styled-components';
import AutoCompleteList from 'components/base/AutoCompleteList';
import { StyledAutoCompleteList } from 'components/base/AutoCompleteList/AutoCompleteList.style';
import { useEffect } from 'react';
import { StyledOrgsCounter } from '../../MonitoringRulesForm.style';
import { pluralize } from 'common/utils/utils';

const StyledGithubOrgsSelector = styled.div`
  display: flex;
  & ${StyledAutoCompleteList} {
    margin-bottom: 3rem;
    width: ${props => props.width};
  }
`;

const GithubOrgsSelector = ({
  githubOrgs,
  integration,
  onChange,
  filterUnExistedOrgs,
  selectedValues,
  disabled = false,
  width = '36rem'
}) => {
  const { options, disabledValues, isLoading } = githubOrgs;

  useEffect(() => {
    if (!isLoading && !integration?.is_on_prem)
      filterUnExistedOrgs?.(options.map(option => option.value));
  }, [options]);

  return (
    <StyledGithubOrgsSelector width={width}>
      <AutoCompleteList
        isLoading={isLoading}
        options={options}
        selectedValues={selectedValues}
        disabledValues={disabledValues}
        onChange={onChange}
        withSelectAll={!integration?.is_on_prem}
        disabled={disabled}
      />
      {!disabled && (
        <StyledOrgsCounter>
          {pluralize(selectedValues.length, 'organization')} currently selected
        </StyledOrgsCounter>
      )}
    </StyledGithubOrgsSelector>
  );
};

export default GithubOrgsSelector;
